module.exports = __webpack_public_path__ + "img/plus.36fffc69.svg";